import React, { useEffect, useRef } from 'react';
import './index.css';
import { FormInputField } from './types';
const dayjs = require('dayjs');

interface InputFieldProps {
  formData: Record<string, any>;
  errorText?: string;
  fieldConfig: FormInputField;
  onChangeHandler?: (val: string, key: string, callbackFn?: any) => void;
  onFocusHandler?: () => void;
  onClickHandler?: () => void;
  customClassName?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  fieldConfig,
  formData,
  onChangeHandler,
  customClassName,
  onFocusHandler,
  onClickHandler
}) => {
  const { type, key, label } = fieldConfig;
  const { val: inputValue, hasError, errorText } = formData?.[key];
  const mobileInputRef = useRef<any>(null);

  // useEffect(() => { // For autofocussing on mobile input field
  //   // focus or blur based on mobile number input size
  //   if (type === 'mobileText') {
  //     if (inputValue?.length < 10) {
  //       mobileInputRef?.current?.focus();
  //     } else {
  //       mobileInputRef?.current?.blur();
  //     }
  //   }
  // }, [inputValue]);

  return (() => {
    switch (type) {
      case 'date': {
        return (
          <div
            className={`floatingInputContainer ${
              hasError ? 'formErrorText' : ''
            }`}
          >
            <div className="floatingStyledInput wide">
              <input
                className={customClassName}
                type="text"
                readOnly
                value={inputValue ? dayjs(inputValue).format('DD/MM/YYYY') : ''}
              />
              {label && (
                <label
                  className={`${
                    inputValue !== '' ? 'stickTop stickTopDate' : ''
                  }`}
                >
                  {label}
                </label>
              )}
            </div>
            {hasError && <p className="formErrorText">{errorText}</p>}
          </div>
        );
      }
      case 'textarea': {
        return (
          <div
            className={`floatingInputContainer ${
              hasError ? 'formErrorText' : ''
            }`}
          >
            <div className="floatingStyledInput wider">
              <textarea
                className={customClassName}
                onChange={e => onChangeHandler?.(e.target.value, key)}
                wrap="hard"
                rows={2}
              >
                {inputValue}
              </textarea>
              <label className={`${inputValue !== '' ? 'stickTop' : ''}`}>
                {label}
              </label>
              <span></span>
            </div>
            {hasError && <p className="formErrorText">{errorText}</p>}
          </div>
        );
      }
      case 'mobileText': {
        return (
          <div
            className={`floatingInputContainer mobileInput ${
              hasError ? 'formErrorText' : ''
            }`}
          >
            <div className="inputContainer number">
              <label>{label}</label>
              <div className={customClassName}>
                <input maxLength={4} className="countryInput" value={'+91'} />
                <span className="latoBold"> - </span>
                <input
                  ref={mobileInputRef}
                  inputMode="numeric"
                  className={`${customClassName} leftPadding10`}
                  value={inputValue}
                  onChange={e => onChangeHandler?.(e.target.value, key)}
                  onClick={e => onClickHandler?.()}
                  maxLength={10}
                />
              </div>
            </div>
            {hasError && <p className="formErrorText">{errorText}</p>}
          </div>
        );
      }
      default: {
        return (
          <div
            className={`floatingInputContainer ${
              hasError ? 'formErrorText' : ''
            }`}
          >
            <div className="floatingStyledInput">
              <input
                className={customClassName}
                type="text"
                value={inputValue}
                onChange={e => onChangeHandler?.(e.target.value, key)}
                onFocus={e => onFocusHandler?.()}
              />
              {label && (
                <label className={`${inputValue !== '' ? 'stickTop' : ''}`}>
                  {label}
                </label>
              )}
              <span></span>
            </div>
            {hasError && <p className="formErrorText">{errorText}</p>}
          </div>
        );
      }
    }
  })();
};

export default InputField;
